export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/earth-fill.898b0d25-c0e4d3.svg";